import Placeholder from './Placeholder';

export default Placeholder;
export { ID, NAME } from './properties';
